export default __webpack_public_path__ + "static/media/royalbets.00aad6ac.png";